// extracted by mini-css-extract-plugin
export default {"paymentMethodWrapper":"styles_paymentMethodWrapper__ZFrw+"};